/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import * as io from 'io-ts';
import { DATASTORE_SERVICE_NAME } from '../../Insights.service.constant';

/**
 * The insights datastore config entity type.
 */
export type EntityInsightsDatastoreConfig = io.TypeOf<typeof InsightsDatastoreConfig>;

/**
 * The insights datastore config entity definition.
 */
export const InsightsDatastoreConfig = io.type(
  {
    eventType: io.literal(DATASTORE_SERVICE_NAME),
    filter: io.type({
      collectionPrefix: io.string,
      datastoreURL: io.string,
    }),
    index: io.type({
      target: io.string,
    }),
    name: io.string,
    properties: io.UnknownRecord,
  },
  `InsightsDatastoreConfig`,
);
